/**
 * Created by baijing on 2018/5/29.
 */

var route = {
    path : '/guide',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/Guide.jsx').default)
        }, 'guide')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/guide.js